module.exports = __webpack_public_path__ + "static/img/tipbutton.21c63680.png";